import { render, staticRenderFns } from "./LWIProgrammeSignup.vue?vue&type=template&id=8f91ec5a&"
import script from "./LWIProgrammeSignup.vue?vue&type=script&lang=js&"
export * from "./LWIProgrammeSignup.vue?vue&type=script&lang=js&"
import style0 from "./LWIProgrammeSignup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports